import Swiper, { Autoplay, Pagination, EffectFade } from 'swiper'

Swiper.use([Autoplay, Pagination, EffectFade])

const showcaseHomepage = new Swiper('.showcase-homepage', {
  loop: true,
  spaceBetween: 0,
  effect: 'fade',
  pagination: {
    enabled: true,
    el: '.showcase-homepage__pagination',
  },
  autoplay: {
    enabled: true,
    delay: 10000,
  },
})

showcaseHomepage


// WEBPACK FOOTER //
// ./scripts/components/showcaseHomepage.js